<template>
  <div id="app" :style="{ opacity: !pageLoading ? 1 : 0 }">
    <BaseComponent />
    <router-view v-if="activityData" />
  </div>
</template>

<script>
import COVERAPP from "@/utils/COVERAPP";
import COVER from "@/utils/COVER";
import BaseComponent from "@/components/Base";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["aid", "pageLoading", "activityData", "shareData"]),
  },
  components: {
    BaseComponent,
  },
  watch: {
    $route(to, from) {
      this.setPageLoadingAsync(true);
      document.querySelector(".loading-wrap").style.display = "block";
    },
  },
  created() {
    this.getActivityData();
  },
  mounted() {
    let _this = this;
    _this.setPageLoadingAsync(false);
    clearTimeout(timeoutIds);
    document.querySelector(".loading-wrap").style.display = "none";
    this.appFlagAsync(COVERAPP.Attribute.isApp());
  },
  methods: {
    ...mapActions([
      "setPageLoadingAsync",
      "appFlagAsync",
      "getActivityDataAsync",
      "Toast",
    ]),
    async getActivityData() {
      const res = await this.$request("/activity/config", "get", {
        aid: this.aid,
      });

      if (res.errno !== 0) {
        return this.Toast({
          text: "网络错误",
        });
      }

      res.data.share && COVER.share(res.data.share);
      this.getActivityDataAsync(res.data);
    },
  },
};
</script>

<style lang="less">
.label {
  cursor: pointer;
}
</style>